import React, { useEffect } from 'react';
import { useLocation} from 'react-router-dom';
import { routes } from '../common/constants';
import { IMPCompleteData, completeInterfaceData } from '../common/entities/interfaz-mercado-pago';
import { RouteComponentProps } from 'react-router-dom';

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

interface PaymentErrorProps extends RouteComponentProps {
  getCartItems: any;
  id?: any;
}

const PaymentError: React.FC<PaymentErrorProps> = (props) => {

  const query = useQuery();

  const completeMpInterface = React.useCallback(async () => {
    const mpInterfaceData: IMPCompleteData = {
      imp_id: query.get('external_reference'),
      imp_collection_id: query.get('collection_id'),
      imp_collection_status: query.get('collection_status'),
      imp_payment_id: query.get('payment_id'),
      imp_payment_status: query.get('status'),
      imp_payment_type: query.get('payment_type'),
      imp_merchant_order_id: query.get('merchant_order_id'),
      imp_preference_id: query.get('preference_id'),
      imp_site_id: query.get('site_id'),
      imp_processing_mode: query.get('processing_mode'),
      imp_merchant_account_id: query.get('merchant_account_id'),
    };

    if (mpInterfaceData.imp_id) {
      await completeInterfaceData(mpInterfaceData);
    }
  }, [query]);

  React.useEffect(() => {
    completeMpInterface();
  }, [completeMpInterface]);

  useEffect(() => {
    props.getCartItems();
  }, []);

  // const rejectOrder = async () => {
  //   const result = await cancelOrder(props.id);
  //   if (!operationSuccess(result)) {
  //     return toast.error(result.statusMsg);
  //   }
  //   props.history.push(routes.home);
  // };

  return (
    <div>
      <div className="page-title">
        <div className="container">
          <div className="column">
            <h1>Error en el pago</h1>
          </div>
          <div className="column">
            <ul className="breadcrumbs">
              <li>Error en el pago</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container padding-bottom-3x mb-2">
        <div className="card text-center">
          <div className="card-body padding-top-2x">
            <i className="icon-x-circle icon-10x-error" />
            <h3 className="card-title margin75em">Hubo un error en el pago</h3>
            <p className="card-text">Puedes cancelar el pedido o intentar nuevamente.</p>
            <div className="padding-top-1x padding-bottom-1x">
              <a className="btn btn-outline-secondary" href={routes.checkout}>
                <i className="icon-arrow-left mr-2 mb-0-5"></i>
                Volver a intentar
              </a>
              <a className="btn btn-outline-secondary" href={routes.home}>
                <i className="icon-arrow-left mr-2 mb-0-5"></i>
                Volver al catálogo
              </a>
            </div>
          </div>
        </div>
      </div>
      <button className="scroll-to-top-btn">
        <i className="icon-chevron-up" />
      </button>
      <div className="site-backdrop" />
    </div>
  );
};

export default PaymentError;
